"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_easy_crop_1 = __importDefault(require("react-easy-crop"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const images_1 = require("../../assets/images");
const cropImage_1 = __importDefault(require("../../utils/cropImage"));
const helpler_1 = require("../../utils/helpler");
const scale_1 = require("../../utils/scale");
const button_1 = require("../button");
const LoadingLogin_1 = __importDefault(require("../loading/LoadingLogin"));
const getMinZoom = (imageSize, cropSize) => {
    const imageRatio = imageSize.width / imageSize.height;
    const cropRatio = cropSize.width / cropSize.height;
    if (imageRatio >= 1) {
        if (cropRatio > imageRatio) {
            return (cropSize.width / scale_1.width);
        }
        const displayImageHeight = scale_1.width / imageRatio;
        return (cropSize.height / displayImageHeight);
    }
    else {
        const displayImageWidth = scale_1.height * imageRatio;
        if (cropRatio > 1) {
            return (cropSize.width / displayImageWidth);
        }
        return (cropSize.width / displayImageWidth);
    }
};
const ModalCropImage = (props) => {
    const { imageSource, imageType, visible, onClose, cropSize, cropShape = 'rect', saveButtonLabel = '完了' } = props;
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const [crop, setCrop] = (0, react_1.useState)({ x: 0, y: 0 });
    const [zoom, setZoom] = (0, react_1.useState)(1);
    const [minZoom, setMinZoom] = (0, react_1.useState)(1);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [imageSize, setImageSize] = (0, react_1.useState)({ width: 1, height: 1 });
    const refCropAreaPixels = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        if (visible) {
            react_native_1.Image.getSize(imageSource, (width, height) => {
                setImageSize({ width, height });
                const _minZoom = getMinZoom({ width, height }, cropSize);
                setMinZoom(_minZoom);
                setZoom(_minZoom);
            });
        }
    }, [visible]);
    const onCropChange = (_, croppedAreaPixels) => {
        if (!refCropAreaPixels.current) {
            refCropAreaPixels.current = croppedAreaPixels;
        }
    };
    const onCropComplete = (_, croppedAreaPixels) => {
        refCropAreaPixels.current = croppedAreaPixels;
    };
    const onApplyCropImage = () => {
        if (!!refCropAreaPixels.current) {
            setLoading(true);
            (0, cropImage_1.default)(imageSource, imageType, refCropAreaPixels.current, 0)
                .then(croppedImage => {
                onClose(croppedImage);
            })
                .catch(error => {
                console.log(error);
            })
                .finally(() => {
                setLoading(false);
            });
        }
        else {
            onClose(imageSource);
        }
    };
    return (react_1.default.createElement(react_native_1.Modal, { transparent: true, statusBarTranslucent: true, visible: visible, animationType: "none", onRequestClose: () => onClose(null), onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        } },
        react_1.default.createElement(react_native_1.ImageBackground, { source: images_1.images.BackGroundPng, style: [styles.container, { width: scale_1.width, alignSelf: 'center' }] },
            react_1.default.createElement(react_easy_crop_1.default, { image: imageSource, crop: crop, cropSize: cropSize, zoom: zoom, minZoom: minZoom, objectFit: imageSize.width >= imageSize.height ?
                    'horizontal-cover'
                    :
                        'vertical-cover', cropShape: cropShape, showGrid: false, onCropAreaChange: onCropChange, onCropChange: setCrop, onZoomChange: setZoom, onCropComplete: onCropComplete }),
            react_1.default.createElement(react_native_1.View, { style: [styles.absoluteView, { bottom: inset.bottom + (0, scale_1.scale)(24) }] },
                react_1.default.createElement(button_1.LinearButton, { title: saveButtonLabel, fontWeight: '600', onPress: onApplyCropImage, style: styles.primaryButton, textStyle: styles.primaryButtonLabel }),
                react_1.default.createElement(button_1.LinearButton, { title: 'キャンセル', fontWeight: '300', onPress: () => onClose(null), style: [styles.primaryButton], colors: ['transparent', 'transparent'], textStyle: [styles.primaryButtonLabel, { fontSize: (0, scale_1.moderateScale)(14) }] })),
            isLoading && react_1.default.createElement(LoadingLogin_1.default, null))));
};
exports.default = ModalCropImage;
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'rgba(0,0,0,1)'
    },
    cropImage: {
        width: '100%',
        height: '100%',
        resizeMode: 'contain',
    },
    absoluteView: {
        position: 'absolute',
        left: 0,
        right: 0,
        paddingHorizontal: (0, scale_1.scale)(24),
        zIndex: 1,
    },
    primaryButton: {
        width: '100%',
        height: (0, scale_1.scale)(48),
        borderRadius: (0, scale_1.scale)(4),
    },
    primaryButtonLabel: {
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        color: '#FEFEFE'
    }
});
